import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import {  useSelector } from "react-redux";
import { Icon } from "@iconify/react";
import { Button, Tooltip } from "@mui/material";
import OrderProcessingTabs from "./OrderProcessingTabs";
import { orderSelector } from "../../../../../redux/slices/orderSlice";
import { Link } from "react-router-dom";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "55%",
  // Grows with its content so the "View All" button stays inside the box.
  maxHeight: "90vh",
  overflowY: "auto",
  textAlign: "center",
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  p: "20px 50px",
  borderRadius: "10px",
};

export default function BatchProcessingModal({ orders, title, processId }) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const { batchProcessOrders } = useSelector(orderSelector);

  return (
    <>
      {!title ? (
        <Button
          variant="deepbluemini"
          onClick={handleOpen}
          sx={{
            background: "white",
            color: "black",
            margin: "10px",
            height: "37px",
            fontSize: "11px",
            "&:hover": {
              background: "rgba(255, 255, 255, 0.6)",
            },
          }}
        >
          Processing Orders (
          {batchProcessOrders?.batch_processes?.length > 0 &&
          batchProcessOrders?.batch_processes[0]?.status === "fulfilled"
            ? 0
            : orders}
          )
        </Button>
      ) : (
        <Tooltip
        title="View Processed Orders"
        placement="top-end"
        TransitionComponent={Fade}
      >

        <Icon
          icon="bi:eye"
          width="20"
          height="20"
          style={{ cursor: "pointer", marginTop: "3px" }}
          onClick={handleOpen}
        />
      </Tooltip>
      )}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
      >
        <Fade in={open}>
          <Box sx={style} className="">
            <h2 style={{ fontSize: "28px" }}>Order Processing Stats</h2>
            <>
              <OrderProcessingTabs processId={processId}/>
            </>
            {!processId && <Link to="batch-process">
              <Button
                variant="deepblue"
                sx={{ width: "50%", margin: "auto", marginTop: "20px" }}
              >
                View all
              </Button>
            </Link>}
          </Box>
        </Fade>
      </Modal>
    </>
  );
}
